export default {
  A: {
    width: 4.59,
    d:
      "M0,7.19,2.13,2.64a.14.14,0,0,1,.11-.07h.07a.14.14,0,0,1,.12.07L4.54,7.19a.12.12,0,0,1-.11.18H3.68c-.12,0-.18,0-.24-.17L3.2,6.66H1.36l-.24.54a.27.27,0,0,1-.25.17H.13A.12.12,0,0,1,0,7.19ZM2.79,5.74,2.28,4.63h0L1.76,5.74Z"
  },
  B: {
    width: 3.28,
    d:
      "M0,2.76a.13.13,0,0,1,.13-.13H1.7A1.37,1.37,0,0,1,3.16,3.89,1.35,1.35,0,0,1,2.37,5a1.28,1.28,0,0,1,.91,1.1A1.38,1.38,0,0,1,1.8,7.37H.13A.13.13,0,0,1,0,7.24ZM1.58,4.55a.47.47,0,0,0,.47-.48.45.45,0,0,0-.47-.46H1.05v.94ZM1.67,6.4a.5.5,0,0,0,.49-.49.55.55,0,0,0-.56-.48H1.05v1Z"
  },
  C: {
    width: 4.12,
    d:
      "M2.44,2.57a2.27,2.27,0,0,1,1.64.63.12.12,0,0,1,0,.19l-.52.54a.11.11,0,0,1-.17,0,1.39,1.39,0,0,0-.92-.34A1.34,1.34,0,0,0,1.15,5,1.34,1.34,0,0,0,2.48,6.35,1.44,1.44,0,0,0,3.39,6a.12.12,0,0,1,.17,0l.53.56a.13.13,0,0,1,0,.18,2.3,2.3,0,0,1-1.64.65,2.43,2.43,0,1,1,0-4.86Z"
  },
  D: {
    width: 4.14,
    d:
      "M0,2.76a.13.13,0,0,1,.12-.13H1.77a2.37,2.37,0,1,1,0,4.74H.12A.12.12,0,0,1,0,7.24ZM1.7,6.37A1.31,1.31,0,0,0,3,5,1.31,1.31,0,0,0,1.7,3.63H1.05V6.37Z"
  },
  E: {
    width: 3.06,
    d:
      "M0,2.76a.13.13,0,0,1,.13-.13h2.8a.14.14,0,0,1,.13.13V3.5a.13.13,0,0,1-.13.13H1.05v.84H2.6a.13.13,0,0,1,.12.13v.73a.12.12,0,0,1-.12.13H1.05v.91H2.93a.13.13,0,0,1,.13.13v.74a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  F: {
    width: 3.06,
    d:
      "M0,2.76a.13.13,0,0,1,.13-.13h2.8a.14.14,0,0,1,.13.13V3.5a.13.13,0,0,1-.13.13H1.05v1H2.6a.13.13,0,0,1,.12.13v.74a.13.13,0,0,1-.12.13H1.05V7.24a.13.13,0,0,1-.12.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  G: {
    width: 4.16,
    d:
      "M2.43,2.57a2.63,2.63,0,0,1,1.65.64.12.12,0,0,1,0,.18L3.56,4a.15.15,0,0,1-.19,0,1.21,1.21,0,0,0-.88-.33,1.36,1.36,0,0,0,0,2.71,1.66,1.66,0,0,0,.61-.1v-.4H2.67a.12.12,0,0,1-.13-.12V5.06a.13.13,0,0,1,.13-.13H4a.12.12,0,0,1,.12.13V6.88A.17.17,0,0,1,4.1,7a3.37,3.37,0,0,1-1.67.44,2.43,2.43,0,1,1,0-4.86Z"
  },
  H: {
    width: 4.06,
    d:
      "M0,2.76a.14.14,0,0,1,.13-.13h.8a.13.13,0,0,1,.13.13V4.47H3V2.76a.14.14,0,0,1,.13-.13h.81a.15.15,0,0,1,.13.13V7.24a.14.14,0,0,1-.13.13H3.12A.13.13,0,0,1,3,7.24V5.46H1.06V7.24a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  I: {
    width: 1.07,
    d:
      "M0,2.76a.14.14,0,0,1,.13-.13H.94a.14.14,0,0,1,.13.13V7.24a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  J: {
    width: 2.5,
    d:
      "M0,6.77l.45-.45a.14.14,0,0,1,.19,0A.42.42,0,0,0,1,6.46c.19,0,.4-.17.4-.51V2.76a.14.14,0,0,1,.13-.13h.82a.13.13,0,0,1,.13.13V6A1.4,1.4,0,0,1,1.05,7.43a1.31,1.31,0,0,1-1-.49A.14.14,0,0,1,0,6.77Z"
  },
  K: {
    width: 3.89,
    d:
      "M0,2.8a.17.17,0,0,1,.16-.17H1a.18.18,0,0,1,.17.17V4.58L2.62,2.7a.19.19,0,0,1,.12-.07H3.6a.17.17,0,0,1,.12.26l-1.58,2L3.86,7.11a.16.16,0,0,1-.13.25H2.8a.17.17,0,0,1-.12-.05L1.12,5.19v2A.17.17,0,0,1,1,7.37H.16A.16.16,0,0,1,0,7.21Z"
  },
  L: {
    width: 2.8,
    d:
      "M0,2.76a.13.13,0,0,1,.13-.13h.8a.14.14,0,0,1,.13.13V6.37H2.67a.13.13,0,0,1,.13.13v.74a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  M: {
    width: 5.37,
    d:
      "M.77,2.68a.12.12,0,0,1,.12-.11H1a.14.14,0,0,1,.11.06L2.68,5.56h0L4.26,2.63a.14.14,0,0,1,.12-.06h.1a.14.14,0,0,1,.13.11l.76,4.54a.13.13,0,0,1-.13.15h-.8a.15.15,0,0,1-.13-.11L4,5.17H4L2.86,7.36a.15.15,0,0,1-.11.07H2.62a.14.14,0,0,1-.11-.07L1.37,5.17h0L1.06,7.26a.14.14,0,0,1-.13.11H.13A.13.13,0,0,1,0,7.22Z"
  },
  N: {
    width: 4.07,
    d:
      "M0,2.69a.12.12,0,0,1,.13-.12H.3L3,5.16H3V2.76a.14.14,0,0,1,.13-.13h.81a.14.14,0,0,1,.13.13V7.31a.12.12,0,0,1-.13.12H3.83l-.09,0L1.07,4.72h0V7.24a.13.13,0,0,1-.13.13H.14A.13.13,0,0,1,0,7.24Z"
  },
  O: {
    width: 4.86,
    d:
      "M2.43,2.57a2.43,2.43,0,1,1,0,4.86,2.43,2.43,0,1,1,0-4.86Zm0,3.78A1.35,1.35,0,1,0,1.08,5,1.35,1.35,0,0,0,2.43,6.35Z"
  },
  P: {
    width: 3.27,
    d:
      "M0,2.76a.13.13,0,0,1,.13-.13H1.76a1.51,1.51,0,1,1,0,3H1.05V7.24a.13.13,0,0,1-.12.13H.13A.13.13,0,0,1,0,7.24Zm1.7,1.9a.53.53,0,0,0,.53-.53.51.51,0,0,0-.53-.5H1.05v1Z"
  },
  Q: {
    width: 4.86,
    d:
      "M2.43,2.57A2.43,2.43,0,0,1,4.86,5,2.55,2.55,0,0,1,3.61,7.14L4.48,8.5a.13.13,0,0,1-.11.21H3.46a.14.14,0,0,1-.11-.07L2.64,7.43H2.43a2.43,2.43,0,1,1,0-4.86Zm0,3.78A1.35,1.35,0,1,0,1.08,5,1.35,1.35,0,0,0,2.43,6.35Z"
  },
  R: {
    width: 3.62,
    d:
      "M0,2.76a.13.13,0,0,1,.13-.13h2A1.47,1.47,0,0,1,3.62,4.1a1.46,1.46,0,0,1-1,1.35l.93,1.72a.13.13,0,0,1-.12.2H2.54a.13.13,0,0,1-.11-.06l-.9-1.79H1.06V7.24a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Zm2.06,1.9a.55.55,0,0,0,.52-.54.52.52,0,0,0-.52-.52h-1V4.66Z"
  },
  S: {
    width: 3.18,
    d:
      "M0,6.72l.32-.56a.19.19,0,0,1,.23,0,1.93,1.93,0,0,0,1,.38A.43.43,0,0,0,2,6.09c0-.28-.24-.5-.7-.68S0,4.72,0,3.91A1.4,1.4,0,0,1,1.56,2.57,2.63,2.63,0,0,1,3,3.07a.17.17,0,0,1,0,.22l-.35.52c0,.08-.17.14-.23.09a2.13,2.13,0,0,0-1-.41.4.4,0,0,0-.43.35c0,.25.2.44.74.65S3.18,5.12,3.18,6A1.48,1.48,0,0,1,1.59,7.43,2.11,2.11,0,0,1,.07,6.91C0,6.85,0,6.82,0,6.72Z"
  },
  T: {
    width: 3.26,
    d:
      "M1.09,3.63h-1A.13.13,0,0,1,0,3.5V2.76a.13.13,0,0,1,.13-.13h3a.14.14,0,0,1,.13.13V3.5a.13.13,0,0,1-.13.13h-1V7.24A.13.13,0,0,1,2,7.37H1.22a.14.14,0,0,1-.13-.13Z"
  },
  U: {
    width: 3.85,
    d:
      "M0,2.76a.14.14,0,0,1,.13-.13H1a.14.14,0,0,1,.13.13V5.5a.84.84,0,1,0,1.67,0V2.76a.14.14,0,0,1,.13-.13h.83a.14.14,0,0,1,.13.13v2.8A1.91,1.91,0,0,1,1.92,7.43,1.9,1.9,0,0,1,0,5.56Z"
  },
  V: {
    width: 4.56,
    d:
      "M0,2.81a.12.12,0,0,1,.12-.18H1a.14.14,0,0,1,.11.08L2.26,5.18h0L3.41,2.71a.15.15,0,0,1,.12-.08h.9a.12.12,0,0,1,.11.18L2.42,7.36a.12.12,0,0,1-.11.07H2.24a.13.13,0,0,1-.12-.07Z"
  },
  W: {
    width: 5.75,
    d:
      "M0,2.8a.12.12,0,0,1,.12-.17H.92a.14.14,0,0,1,.12.1L1.62,5h0L2.7,2.64a.12.12,0,0,1,.11-.07h.12c.07,0,.11,0,.12.07L4.1,5h0l.59-2.29a.13.13,0,0,1,.12-.1h.79a.12.12,0,0,1,.12.17L4.46,7.34a.13.13,0,0,1-.12.09H4.23a.12.12,0,0,1-.11-.07L2.88,4.6h0L1.63,7.36a.14.14,0,0,1-.12.07h-.1a.14.14,0,0,1-.13-.09Z"
  },
  X: {
    width: 4.14,
    d:
      "M1.44,4.94.08,2.82a.12.12,0,0,1,.11-.19h1a.14.14,0,0,1,.11.07L2.07,4h0L2.86,2.7A.14.14,0,0,1,3,2.63H4a.12.12,0,0,1,.11.19L2.7,4.94,4.12,7.18A.12.12,0,0,1,4,7.37H3.07A.15.15,0,0,1,3,7.31L2.07,5.94h0L1.19,7.31a.17.17,0,0,1-.11.06H.14C0,7.37,0,7.27,0,7.18Z"
  },
  Y: {
    width: 4.11,
    d:
      "M1.52,5.09,0,2.83a.13.13,0,0,1,.11-.2H1a.14.14,0,0,1,.11.07l.94,1.38L3,2.7s0-.07.1-.07H4a.13.13,0,0,1,.11.2L2.58,5.08V7.24a.13.13,0,0,1-.13.13H1.64a.12.12,0,0,1-.12-.13Z"
  },
  Z: {
    width: 3.33,
    d:
      "M0,7.12,1.8,3.64H.32A.13.13,0,0,1,.2,3.5V2.76a.14.14,0,0,1,.12-.13H3.2a.15.15,0,0,1,.13.13v.09L1.59,6.36H3.06a.13.13,0,0,1,.13.13v.74a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  }
};
